import type VideoPlayer from '../../types/VideoPlayer'
import { APPSTATE } from '../state/state.app'
import { slugToID, USERSSTATE } from '../state/state.users'
import {
    FCVIDEO_RX_CLUB,
    FCVIDEO_RX_GRP,
    FCVIDEO_RX_IDLE,
    FCVIDEO_RX_PVT,
    FCVIDEO_RX_VOY,
    PLATFORM_MFC,
} from './mfcConstants'

export type VideoConfig = VideoPlayer.Options

export const generateVideoConfig = (
    id: number,
    videoPlayer?: VideoPlayer.Instance,
): VideoConfig => {
    const user = USERSSTATE[id]
    const self = USERSSTATE[slugToID['me']]

    if (!user || !self) return

    const {
        streamType: modelStreamType,
        flags: modelFlags,
        state: modelState,
        isWowzaOBSVideo,
        isOBSExtVideo,
        sessionChannel,
        isTruePrivate,
        privateShow,
        id: modelId,
        isNGVideo,
        groupShow,
        clubShow,
        channel,
        server,
        phase,
    } = user

    const streamType = modelStreamType || 'public'
    const useTkxAuth = isNGVideo || isWowzaOBSVideo || streamType !== 'public'
    const insideClubShow = streamType === 'club'

    if (typeof videoPlayer === 'function') {
        videoPlayer.prototype.REPORTBACK = true
        videoPlayer.prototype.REPORTBACK_EXTRA = {
            new_release: 1,
        }
    }

    const config: VideoConfig = {
        cxid: useTkxAuth
            ? () => USERSSTATE[slugToID['me']].auth?.cxid
            : () => 0,
        vidctx: useTkxAuth
            ? () => {
                  const tokens = insideClubShow
                      ? clubShow.ckx_auth
                      : (USERSSTATE[slugToID['me']].auth ?? {})
                  return encodeURIComponent(btoa(JSON.stringify(tokens.ctx)))
              }
            : () => '',
        password: useTkxAuth
            ? () => {
                  const tokens = insideClubShow
                      ? clubShow.ckx_auth
                      : (USERSSTATE[slugToID['me']].auth ?? {})
                  return tokens.tkx
              }
            : () => APPSTATE.app.passcode || '',
        urlFormat: isWowzaOBSVideo ? 'wowza' : isNGVideo ? 'nginx' : 'wowza',
        videoDomain: server ? 'video' + server + '.myfreecams.com' : null,
        imageUrl: 'https://img.mfcimg.com/',
        platformId: PLATFORM_MFC,
        aspectRatio: '16:9',
        phase:
            isOBSExtVideo &&
            (streamType === 'private' || streamType === 'voyeur')
                ? 'p'
                : isOBSExtVideo && streamType === 'group'
                  ? 'g'
                  : isNGVideo
                    ? phase
                    : 'z',
        ckxauth:
            streamType === 'private' || streamType === 'voyeur'
                ? () => privateShow?.ckx_auth?.ctxenc
                : streamType === 'group'
                  ? () => groupShow?.ckx_auth?.ctxenc
                  : () => undefined,
        state:
            streamType === 'club'
                ? FCVIDEO_RX_CLUB
                : streamType === 'private'
                  ? FCVIDEO_RX_PVT
                  : streamType === 'voyeur'
                    ? FCVIDEO_RX_VOY
                    : streamType === 'group'
                      ? FCVIDEO_RX_GRP
                      : FCVIDEO_RX_IDLE,
        allowControls: true,
        onlyVolumeControls: false,
        modelState,
        modelFlags,
        modelId,
        sessionId: () => USERSSTATE[slugToID['me']].session,
        videoId: `video-${modelId}`,
        roomId: streamType === 'public' ? channel : sessionChannel,
        truepvt: isTruePrivate,
        render: false,
        c2c: false,
        pvtsession:
            streamType === 'private' || streamType === 'voyeur'
                ? privateShow?.sessionID
                : 0,
        grpsession: streamType === 'group' ? groupShow?.sessionID : 0,
        clbsession: insideClubShow ? clubShow.tksid : 0,
        // logFn: m => {
        //     console.log('VideoPlayerJS:', m)
        // },
    }

    return config
}
